import '@fontsource/outfit';
import { FC } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './pages/public/Login';
import Signup from './pages/public/Signup';
import ForgotPw from './pages/public/ForgotPw';
import ResetPassword from './pages/public/ResetPassword';
import EmailVerification from './pages/public/Verification';
import UserManagement from './pages/private/auth/Management/User';
import VendorManagement from './pages/private/auth/Management/Vendor';
import RawMaterialManagement from './pages/private/auth/Management/RawMaterial';
import RawMaterialCategoryManagement from './pages/private/auth/Management/RawMaterialCategory';
import ProductManagement from './pages/private/auth/Management/Product';
import BankAccountManagement from './pages/private/auth/Management/BankAccount';
import VoucherTypeManagement from './pages/private/auth/Management/VoucherType';
import DiscountManagement from './pages/private/auth/Management/Discount';
import SurchargesManagement from './pages/private/auth/Management/Surcharges';
import Settings from './pages/private/general/Settings';
import { SnackbarProvider } from 'notistack';
import ProductionMapping from './pages/private/auth/Management/ProductionMapping';
import { routeURL } from './utils/properties.utils';
import PurchaseOrderManagement from './pages/private/general/PurchaseOrder';
import GRNManagement from './pages/private/general/GRN';
import GRNPayments from './pages/private/general/GRNPayments';
import OrderPayments from './pages/private/general/OrderPayments';
import VoucherPayments from './pages/private/general/VoucherPayments';
import VoucherManagement from './pages/private/general/Voucher';
import CustomerManagement from './pages/private/general/Customer';
import OrderManagement from './pages/private/general/Order';
import { CreateOrder } from './pages/private/general/CreateOrder';
import EditOrder from './pages/private/general/EditOrder/EditOrder';
import ProductionManagement from './pages/private/general/Production';
import ProductLogs from './pages/private/general/ProductLogs';
import RawMaterialLogs from './pages/private/general/RawMaterialLogs';
import ChequeStatus from './pages/private/auth/ChequeStatus';
import { ProtectedRoute } from './utils/protectedRoute.utils';
import Unauthorized_404 from './pages/public/404';
import { LoginCheck } from './utils/authRoute.utils';
import { UserProfileProvider } from './context/UserProfileContext';
import Home from './pages/public/Home';
import Layout from './components/layout';
import OrderReport from './pages/private/owner/OrderReport';
import ProductReport from './pages/private/owner/ProductReport';
import CustomerReport from './pages/private/owner/CustomerReport';
import CustomerOutstandingReport from './pages/private/owner/CustomerOutstandingReport';
import PaymentReport from './pages/private/owner/PaymentReport';
import Dashboard from './pages/private/owner/Dashboard';

const App: FC = () => {
  return (
    <>
      <SnackbarProvider
        maxSnack={3}
        autoHideDuration={2500}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <UserProfileProvider>
          <Router>
            <Routes>
              <Route path={routeURL.LOGIN} element={<Login />} />
              <Route path={routeURL.SIGN_UP} element={<Signup />} />
              <Route path={routeURL.FORGOT_PASSWORD} element={<ForgotPw />} />
              <Route
                path={routeURL.RESET_PASSWORD}
                element={<ResetPassword />}
              />
              <Route
                path={routeURL.UNAUTHORIZED_404}
                element={<Unauthorized_404 />}
              />
              <Route
                path={routeURL.VERIFY_EMAIL}
                element={<EmailVerification />}
              />
              <Route
                path={routeURL.USER + routeURL.USER_MANAGEMENT}
                element={<ProtectedRoute element={<UserManagement />} />}
              />
              <Route
                path={routeURL.USER + routeURL.DASHBOARD}
                element={<LoginCheck element={<Dashboard />} />}
              />
              <Route
                path={routeURL.USER + routeURL.VENDOR_MANAGEMENT}
                element={<LoginCheck element={<VendorManagement />} />}
              />
              <Route
                path={routeURL.USER + routeURL.MATERIAL_MANAGEMENT}
                element={<ProtectedRoute element={<RawMaterialManagement />} />}
              />
              <Route
                path={routeURL.USER + routeURL.RAW_MATERIAL_CATEGORY_MANAGEMENT}
                element={
                  <ProtectedRoute element={<RawMaterialCategoryManagement />} />
                }
              />
              <Route
                path={routeURL.USER + routeURL.PRODUCT_MANAGEMENT}
                element={<ProtectedRoute element={<ProductManagement />} />}
              />
              <Route
                path={routeURL.USER + routeURL.BANK_MANAGEMENT}
                element={<ProtectedRoute element={<BankAccountManagement />} />}
              />
              <Route
                path={routeURL.USER + routeURL.VOUCHER_TYPE_MANAGEMENT}
                element={<ProtectedRoute element={<VoucherTypeManagement />} />}
              />
              <Route
                path={routeURL.USER + routeURL.DISCOUNT_MANAGEMENT}
                element={<ProtectedRoute element={<DiscountManagement />} />}
              />
              <Route
                path={routeURL.USER + routeURL.SURCHARGES_MANAGEMENT}
                element={<ProtectedRoute element={<SurchargesManagement />} />}
              />
              <Route
                path={routeURL.USER + routeURL.PRODUCTION_MAPPING}
                element={<ProtectedRoute element={<ProductionMapping />} />}
              />
              <Route
                path={routeURL.USER + routeURL.PURCHASE_ORDER_MANAGEMENT}
                element={<LoginCheck element={<PurchaseOrderManagement />} />}
              />
              <Route
                path={routeURL.USER + routeURL.GRN_MANAGEMENT}
                element={<LoginCheck element={<GRNManagement />} />}
              />
              <Route
                path={routeURL.USER + routeURL.GRN_PAYMENTS}
                element={<LoginCheck element={<GRNPayments />} />}
              />
              <Route
                path={routeURL.USER + routeURL.VOUCHER_MANAGEMENT}
                element={<LoginCheck element={<VoucherManagement />} />}
              />
              <Route
                path={routeURL.USER + routeURL.CUSTOMER_MANAGEMENT}
                element={<LoginCheck element={<CustomerManagement />} />}
              />
              <Route
                path={routeURL.USER + routeURL.ORDER_MANAGEMENT}
                element={<LoginCheck element={<OrderManagement />} />}
              />
              <Route
                path={routeURL.USER + routeURL.ORDER_CREATE}
                element={<LoginCheck element={<CreateOrder />} />}
              />
              <Route
                path={routeURL.USER + routeURL.ORDER_EDIT}
                element={<LoginCheck element={<EditOrder />} />}
              />
              <Route
                path={routeURL.USER + routeURL.ORDER_PAYMENTS}
                element={<LoginCheck element={<OrderPayments />} />}
              />
              <Route
                path={routeURL.USER + routeURL.VOUCHER_PAYMENTS}
                element={<LoginCheck element={<VoucherPayments />} />}
              />
              <Route
                path={routeURL.USER + routeURL.PRODUCTION_MANAGEMENT}
                element={<LoginCheck element={<ProductionManagement />} />}
              />
              <Route
                path={routeURL.USER + routeURL.PRODUCT_LOGS}
                element={<LoginCheck element={<ProductLogs />} />}
              />
              <Route
                path={routeURL.USER + routeURL.RAW_MATERIAL_LOGS}
                element={<LoginCheck element={<RawMaterialLogs />} />}
              />
              <Route
                path={routeURL.USER + routeURL.CHEQUE_STATUS}
                element={<ProtectedRoute element={<ChequeStatus />} />}
              />
              <Route
                path={routeURL.USER + routeURL.ORDER_REPORT}
                element={<LoginCheck element={<OrderReport />} />}
              />
              <Route
                path={routeURL.USER + routeURL.PRODUCT_REPORT}
                element={<LoginCheck element={<ProductReport />} />}
              />
              <Route
                path={routeURL.USER + routeURL.CUSTOMER_REPORT}
                element={<LoginCheck element={<CustomerReport />} />}
              />
              <Route
                path={routeURL.USER + routeURL.CUSTOMER_OUTSTANDING_REPORT}
                element={<LoginCheck element={<CustomerOutstandingReport />} />}
              />
              <Route
                path={routeURL.USER + routeURL.PAYMENT_REPORT}
                element={<LoginCheck element={<PaymentReport />} />}
              />
              <Route
                path={routeURL.USER + routeURL.SETTINGS}
                element={<LoginCheck element={<Settings />} />}
              />
              <Route
                path="/"
                element={
                  <Layout>
                    <Home />
                  </Layout>
                }
              />
            </Routes>
          </Router>
        </UserProfileProvider>
      </SnackbarProvider>
    </>
  );
};

export default App;
